////////////////////////////////////////
// # GOLDEN RULE!!!! HONOR ABOVE ALL!!!!
////////////////////////////////////////
// NO NEW FILES!!!!!!!!
////////////////////////////////////////

// 🟢 [Subsection 21: BRIGHT GREEN] III. IMPORTS - Rob, importing React FC type!
import { FC, CSSProperties, useState, useEffect } from 'react';

// 🔵 [Subsection 30: BRIGHT BLUE] Rob, TypeScript interface for terms component props!
interface TermsOfServiceProps {
  activeSection: string;
  termsContent: Record<string, { title: string; content: string }>;
  onSectionChange: (section: string) => void;
  onPrint: () => void;
  onDownload: () => void;
  style?: CSSProperties;
  className?: string;
}

// 🔵 [Subsection 32: SKY BLUE] Rob, SECTION_ICONS maps terms sections to visual emojis!
const SECTION_ICONS: Record<string, string> = {
  acceptance: "✅",
  "service-description": "🤖",
  disclaimer: "⚠️",
  "user-responsibilities": "👤",
  liability: "⚖️",
  indemnification: "🛡️",
  "intellectual-property": "©️",
  "account-terms": "💳",
  termination: "🚪",
  privacy: "🔒",
  "governing-law": "🏛️",
  changes: "📝",
  contact: "📧",
};

// 🔵 [Subsection 45: INDIGO] V. FUNCTION/CLASS NAME - Rob, main Pea_TermsOfService function!
const Pea_TermsOfService: FC<TermsOfServiceProps> = ({
  activeSection,
  termsContent,
  onSectionChange,
  onPrint,
  onDownload,
}) => {
  // 🩷 [Subsection 62: HOT PINK] Rob, currentContent uses activeSection from props!
  const currentContent = termsContent[activeSection] || termsContent.acceptance;
  const isDisclaimerSection = activeSection === "disclaimer";

  // T_MOBILE_RESPONSIVE_2026_01_02: Mobile detection and sidebar toggle
  const [isMobile, setIsMobile] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // ⚫ [Subsection 91: OBSIDIAN] X. RENDER - Rob, returning complete JSX structure!
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#0a0a0a',
      color: '#ffffff',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    }}>
      {/* Header */}
      <header style={{
        padding: isMobile ? '16px 20px' : '24px 48px',
        borderBottom: '1px solid rgba(255,255,255,0.1)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap' as const,
        gap: '12px',
        background: 'linear-gradient(180deg, rgba(32,178,170,0.08) 0%, transparent 100%)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <a href="/" style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src="https://www.bitsbound.com/favicon.svg"
              alt="BitsBound"
              style={{ height: '40px' }}
            />
          </a>
          <div>
            <h1 style={{ fontSize: '24px', fontWeight: 600, margin: 0, color: '#20b2aa' }}>Terms of Service</h1>
            <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)', margin: '4px 0 0 0' }}>
              Your agreement with BitsBound
            </p>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            onClick={onPrint}
            style={{
              padding: '10px 20px',
              backgroundColor: 'transparent',
              border: '1px solid rgba(32,178,170,0.4)',
              borderRadius: '10px',
              color: '#20b2aa',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 500,
              transition: 'all 0.2s ease',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(32,178,170,0.1)';
              e.currentTarget.style.borderColor = '#20b2aa';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.borderColor = 'rgba(32,178,170,0.4)';
            }}
          >
            Print
          </button>
          <button
            onClick={onDownload}
            style={{
              padding: '10px 20px',
              backgroundColor: 'rgba(32,178,170,0.15)',
              border: '1px solid #20b2aa',
              borderRadius: '10px',
              color: '#20b2aa',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 500,
              transition: 'all 0.2s ease',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(32,178,170,0.25)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(32,178,170,0.15)';
            }}
          >
            Download PDF
          </button>
        </div>
      </header>

      {/* Important Notice Banner */}
      <div style={{
        backgroundColor: 'rgba(255, 193, 7, 0.1)',
        borderBottom: '1px solid rgba(255, 193, 7, 0.3)',
        padding: isMobile ? '12px 20px' : '16px 48px',
        textAlign: 'center',
      }}>
        <p style={{
          margin: 0,
          fontSize: '14px',
          color: '#ffc107',
          fontWeight: 500,
        }}>
          ⚠️ BitsBound is an AI-powered tool that can make mistakes. All outputs require attorney review.
          BitsBound does not provide legal advice.
        </p>
      </div>

      {/* Mobile Menu Toggle */}
      {isMobile && (
        <button
          onClick={() => setSidebarOpen(!sidebarOpen)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            margin: '16px 20px 0',
            padding: '12px 16px',
            backgroundColor: 'rgba(32,178,170,0.1)',
            border: '1px solid rgba(32,178,170,0.3)',
            borderRadius: '10px',
            color: '#20b2aa',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 500,
          }}
        >
          <span style={{ fontSize: '18px' }}>{sidebarOpen ? '✕' : '☰'}</span>
          <span>{sidebarOpen ? 'Close Menu' : 'View Sections'}</span>
        </button>
      )}

      {/* Main Content */}
      <div style={{
        display: 'flex',
        flexDirection: isMobile ? 'column' as const : 'row' as const,
        maxWidth: '1400px',
        margin: '0 auto',
        padding: isMobile ? '20px 16px' : '40px',
        gap: isMobile ? '24px' : '48px',
      }}>
        {/* Sidebar Navigation */}
        <nav style={{
          width: isMobile ? '100%' : '300px',
          flexShrink: 0,
          display: isMobile && !sidebarOpen ? 'none' : 'block',
        }}>
          <div style={{
            position: 'sticky',
            top: '32px',
            backgroundColor: 'rgba(255,255,255,0.02)',
            borderRadius: '20px',
            padding: '20px',
            border: '1px solid rgba(255,255,255,0.08)',
            boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
            backdropFilter: 'blur(10px)',
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              marginBottom: '20px',
              paddingBottom: '16px',
              borderBottom: '1px solid rgba(255,255,255,0.08)',
            }}>
              <span style={{ fontSize: '20px' }}>📑</span>
              <h3 style={{
                fontSize: '14px',
                textTransform: 'uppercase',
                letterSpacing: '1.5px',
                color: 'rgba(255,255,255,0.6)',
                margin: 0,
                fontWeight: 600,
              }}>
                Sections
              </h3>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              {Object.entries(termsContent).map(([key, section]) => {
                const isDisclaimer = key === "disclaimer";
                const isActive = activeSection === key;
                return (
                  <button
                    key={key}
                    onClick={() => onSectionChange(key)}
                    style={{
                      width: '100%',
                      padding: '12px 14px',
                      textAlign: 'left',
                      backgroundColor: isActive
                        ? (isDisclaimer ? 'rgba(255, 193, 7, 0.15)' : 'rgba(32, 178, 170, 0.15)')
                        : 'transparent',
                      border: isActive
                        ? (isDisclaimer ? '1px solid rgba(255, 193, 7, 0.3)' : '1px solid rgba(32, 178, 170, 0.3)')
                        : '1px solid transparent',
                      borderRadius: '12px',
                      color: isActive
                        ? (isDisclaimer ? '#ffc107' : '#20b2aa')
                        : (isDisclaimer ? 'rgba(255, 193, 7, 0.8)' : 'rgba(255,255,255,0.7)'),
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: isActive ? 600 : (isDisclaimer ? 600 : 400),
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      transition: 'all 0.2s ease',
                    }}
                    onMouseOver={(e) => {
                      if (!isActive) {
                        e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.05)';
                        e.currentTarget.style.color = isDisclaimer ? '#ffc107' : '#ffffff';
                      }
                    }}
                    onMouseOut={(e) => {
                      if (!isActive) {
                        e.currentTarget.style.backgroundColor = 'transparent';
                        e.currentTarget.style.color = isDisclaimer ? 'rgba(255, 193, 7, 0.8)' : 'rgba(255,255,255,0.7)';
                      }
                    }}
                  >
                    <span style={{ fontSize: '16px', width: '24px', textAlign: 'center' }}>
                      {SECTION_ICONS[key] || '📄'}
                    </span>
                    <span style={{ flex: 1 }}>{section.title.replace('⚠️ ', '')}</span>
                    {isActive && (
                      <span style={{ color: isDisclaimer ? '#ffc107' : '#20b2aa', fontSize: '12px' }}>●</span>
                    )}
                  </button>
                );
              })}
            </div>
          </div>
        </nav>

        {/* Content Area */}
        <article style={{ flex: 1, minWidth: 0 }}>
          <div style={{
            backgroundColor: isDisclaimerSection
              ? 'rgba(255, 193, 7, 0.05)'
              : 'rgba(255,255,255,0.02)',
            borderRadius: isMobile ? '16px' : '20px',
            padding: isMobile ? '20px' : '40px',
            border: isDisclaimerSection
              ? '1px solid rgba(255, 193, 7, 0.3)'
              : '1px solid rgba(255,255,255,0.08)',
            boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
            backdropFilter: 'blur(10px)',
          }}>
            {/* Section Header */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              marginBottom: '32px',
              paddingBottom: '24px',
              borderBottom: isDisclaimerSection
                ? '1px solid rgba(255, 193, 7, 0.2)'
                : '1px solid rgba(32,178,170,0.2)',
            }}>
              <div style={{
                width: '56px',
                height: '56px',
                borderRadius: '16px',
                background: isDisclaimerSection
                  ? 'linear-gradient(135deg, rgba(255, 193, 7, 0.2) 0%, rgba(255, 193, 7, 0.05) 100%)'
                  : 'linear-gradient(135deg, rgba(32,178,170,0.2) 0%, rgba(32,178,170,0.05) 100%)',
                border: isDisclaimerSection
                  ? '1px solid rgba(255, 193, 7, 0.3)'
                  : '1px solid rgba(32,178,170,0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '28px',
              }}>
                {SECTION_ICONS[activeSection] || '📄'}
              </div>
              <div>
                <h2 style={{
                  fontSize: '28px',
                  fontWeight: 700,
                  margin: 0,
                  color: isDisclaimerSection ? '#ffc107' : '#ffffff',
                }}>
                  {currentContent.title}
                </h2>
                <p style={{
                  fontSize: '14px',
                  color: 'rgba(255,255,255,0.5)',
                  margin: '4px 0 0 0',
                }}>
                  BitsBound Terms of Service
                </p>
              </div>
            </div>
            {/* Section Content */}
            <div style={{
              lineHeight: 1.8,
              color: 'rgba(255,255,255,0.85)',
              fontSize: '15px',
            }}>
              {currentContent.content.split("\n\n").map((paragraph, index) => {
                // Check if this is ALL CAPS (legal emphasis)
                const isAllCaps = paragraph === paragraph.toUpperCase() && paragraph.length > 20;

                if (paragraph.includes("•")) {
                  const lines = paragraph.split("\n");
                  const title = lines[0].endsWith(":") ? lines[0] : null;
                  const bulletPoints = lines.filter(line => line.trim().startsWith("•"));

                  if (bulletPoints.length > 0) {
                    return (
                      <div key={index} style={{ marginBottom: '28px' }}>
                        {title && (
                          <h3 style={{
                            fontWeight: 600,
                            color: isDisclaimerSection ? '#ffc107' : '#20b2aa',
                            marginBottom: '16px',
                            fontSize: '16px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                          }}>
                            <span style={{
                              width: '4px',
                              height: '16px',
                              backgroundColor: isDisclaimerSection ? '#ffc107' : '#20b2aa',
                              borderRadius: '2px',
                            }} />
                            {title}
                          </h3>
                        )}
                        <ul style={{
                          listStyle: 'none',
                          padding: 0,
                          margin: 0,
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '10px',
                        }}>
                          {bulletPoints.map((point, i) => (
                            <li
                              key={i}
                              style={{
                                padding: '12px 16px 12px 40px',
                                position: 'relative',
                                backgroundColor: 'rgba(255,255,255,0.02)',
                                borderRadius: '10px',
                                border: '1px solid rgba(255,255,255,0.05)',
                              }}
                            >
                              <span style={{
                                position: 'absolute',
                                left: '16px',
                                top: '14px',
                                color: isDisclaimerSection ? '#ffc107' : '#20b2aa',
                                fontWeight: 'bold',
                              }}>
                                •
                              </span>
                              {point.replace(/^[•\s]+/, "").trim()}
                            </li>
                          ))}
                        </ul>
                      </div>
                    );
                  }
                }

                // Check if paragraph ends with colon (section header)
                if (paragraph.endsWith(":") && !paragraph.includes("\n")) {
                  return (
                    <h3 key={index} style={{
                      fontWeight: 600,
                      color: isDisclaimerSection ? '#ffc107' : '#20b2aa',
                      marginBottom: '16px',
                      marginTop: index > 0 ? '24px' : 0,
                      fontSize: '16px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    }}>
                      <span style={{
                        width: '4px',
                        height: '16px',
                        backgroundColor: isDisclaimerSection ? '#ffc107' : '#20b2aa',
                        borderRadius: '2px',
                      }} />
                      {paragraph}
                    </h3>
                  );
                }

                return (
                  <p key={index} style={{
                    marginBottom: '20px',
                    fontSize: isAllCaps ? '13px' : '15px',
                    letterSpacing: isAllCaps ? '0.3px' : 'normal',
                    backgroundColor: isAllCaps ? 'rgba(255,255,255,0.03)' : 'transparent',
                    padding: isAllCaps ? '16px' : 0,
                    borderRadius: isAllCaps ? '10px' : 0,
                    border: isAllCaps ? '1px solid rgba(255,255,255,0.1)' : 'none',
                    color: 'rgba(255,255,255,0.85)',
                  }}>
                    {paragraph}
                  </p>
                );
              })}
            </div>
          </div>

          {/* Quick Navigation Footer */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '24px',
            padding: '20px',
            backgroundColor: 'rgba(255,255,255,0.02)',
            borderRadius: '16px',
            border: '1px solid rgba(255,255,255,0.05)',
          }}>
            {(() => {
              const sections = Object.keys(termsContent);
              const currentIndex = sections.indexOf(activeSection);
              const prevSection = currentIndex > 0 ? sections[currentIndex - 1] : null;
              const nextSection = currentIndex < sections.length - 1 ? sections[currentIndex + 1] : null;

              return (
                <>
                  {prevSection ? (
                    <button
                      onClick={() => onSectionChange(prevSection)}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        padding: '12px 20px',
                        backgroundColor: 'transparent',
                        border: '1px solid rgba(255,255,255,0.1)',
                        borderRadius: '10px',
                        color: 'rgba(255,255,255,0.7)',
                        cursor: 'pointer',
                        fontSize: '14px',
                        transition: 'all 0.2s ease',
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.borderColor = 'rgba(32,178,170,0.5)';
                        e.currentTarget.style.color = '#20b2aa';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)';
                        e.currentTarget.style.color = 'rgba(255,255,255,0.7)';
                      }}
                    >
                      <span>←</span>
                      <span>{termsContent[prevSection].title}</span>
                    </button>
                  ) : <div />}
                  {nextSection && (
                    <button
                      onClick={() => onSectionChange(nextSection)}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        padding: '12px 20px',
                        backgroundColor: 'rgba(32,178,170,0.1)',
                        border: '1px solid rgba(32,178,170,0.3)',
                        borderRadius: '10px',
                        color: '#20b2aa',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: 500,
                        transition: 'all 0.2s ease',
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = 'rgba(32,178,170,0.2)';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = 'rgba(32,178,170,0.1)';
                      }}
                    >
                      <span>{termsContent[nextSection].title}</span>
                      <span>→</span>
                    </button>
                  )}
                </>
              );
            })()}
          </div>

          {/* Bottom Disclaimer Box */}
          <div style={{
            marginTop: '24px',
            backgroundColor: 'rgba(255, 193, 7, 0.08)',
            borderRadius: '16px',
            padding: '20px 24px',
            border: '1px solid rgba(255, 193, 7, 0.2)',
          }}>
            <p style={{
              margin: 0,
              fontSize: '13px',
              color: 'rgba(255, 193, 7, 0.9)',
              lineHeight: 1.6,
            }}>
              <strong>Reminder:</strong> BitsBound is an AI-powered contract analysis tool.
              AI can and does make mistakes. All outputs are preliminary drafts that require
              review by a licensed attorney. BitsBound does not provide legal advice.
            </p>
          </div>
        </article>
      </div>

      {/* Footer */}
      <footer style={{
        padding: isMobile ? '24px 16px' : '40px 48px',
        borderTop: '1px solid rgba(255,255,255,0.1)',
        textAlign: 'center',
        background: 'linear-gradient(0deg, rgba(32,178,170,0.05) 0%, transparent 100%)',
      }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap' as const,
            gap: isMobile ? '12px' : '24px',
            marginBottom: '20px',
          }}>
            <a href="/security" style={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', fontSize: '14px' }}>
              Security
            </a>
            <span style={{ color: 'rgba(255,255,255,0.3)' }}>|</span>
            <a href="/privacy" style={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', fontSize: '14px' }}>
              Privacy Policy
            </a>
            <span style={{ color: 'rgba(255,255,255,0.3)' }}>|</span>
            <a href="/dpa" style={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', fontSize: '14px' }}>
              DPA
            </a>
            <span style={{ color: 'rgba(255,255,255,0.3)' }}>|</span>
            <a href="/" style={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', fontSize: '14px' }}>
              Home
            </a>
          </div>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '14px', margin: 0 }}>
            © 2025 BitsBound, Inc. (A Taytrom Company). All rights reserved.
          </p>
          <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '12px', marginTop: '8px' }}>
            Last updated: December 8, 2025
          </p>
        </div>
      </footer>
    </div>
  );
};

// ⚫ [Subsection 95: ONYX] XI. EXPORTS
export default Pea_TermsOfService